// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

import { getMessaging } from 'firebase/messaging'
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyAeo9v7mBPv3HPJ1uPIOw09ZQbPLzMvgnw',
  authDomain: 'ft-push-e5b52.firebaseapp.com',
  projectId: 'ft-push-e5b52',
  storageBucket: 'ft-push-e5b52.firebasestorage.app',
  messagingSenderId: '790795500640',
  appId: '1:790795500640:web:5c9a71a41e6f221350d705',
  measurementId: 'G-VXFLSM9Z5D'
}

// Initialize Firebase with a unique name to avoid conflict with the default [DEFAULT] app
export const app = initializeApp(firebaseConfig, 'fcm-test-app')
export const messaging = getMessaging(app)
// const analytics = getAnalytics(app)
